import { render } from "./FeedbackButtons.vue?vue&type=template&id=32c411e3&scoped=true"
import script from "./FeedbackButtons.vue?vue&type=script&lang=js"
export * from "./FeedbackButtons.vue?vue&type=script&lang=js"

import "./FeedbackButtons.vue?vue&type=style&index=0&id=32c411e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c411e3"]])

export default __exports__